import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdChevronRight } from 'react-icons/md';

const ChevronRight: React.FC<IconBaseProps> = (props) => (
  <MdChevronRight {...props} />
);

export default ChevronRight;
